import clsx from "clsx"
import Button from "components/EvtKit/button/Button"
import Heading from "components/Typography/Heading"
import { memo, useCallback } from "react"
import { IoMdAddCircleOutline } from "react-icons/io"
import styled from "styled-components"
import { Colors } from "themes/palette"
import Board from "./ProductBoard"
import { useNavigate } from "react-router-dom"

const ContainerTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

const ButtonCustom = styled(Button)`
  width: 330px;
  margin-right: 24px;
`

interface Props {
  hasData: boolean
}

const ProductHeader = (props: Props) => {
  const { hasData } = props

  const navigate = useNavigate()

  const navigateToCreateStep = useCallback(() => {
    navigate("/products/create")
  }, [])

  return (
    <>
      <ContainerTitle>
        <Heading variant="h3">Produtos</Heading>
        {hasData && (
          <>
            <ButtonCustom
              onClick={navigateToCreateStep}
              iconLeft={<IoMdAddCircleOutline size={24} color={Colors.white} />}
              label="Criar novo Produto"
              className={clsx("background-gradient")}
            />
          </>
        )}
      </ContainerTitle>
      {!hasData && <Board navigateToCreateStep={navigateToCreateStep} />}
    </>
  )
}

export default memo(ProductHeader)
